let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

function markComplianceDisclaimers(scope = document) {
  const disclaimerLead =
    "these statements have not been evaluated by the food and drug administration";
  const candidates = scope.querySelectorAll?.("p") || [];

  candidates.forEach((paragraph) => {
    if (paragraph.textContent.trim().toLowerCase().includes(disclaimerLead)) {
      paragraph.classList.add("compliance-disclaimer");
    }
  });
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

class RechargeDiscountBadgeFormatter {
  constructor() {
    this.widgetRootObservers = new WeakMap();
    this.upsellRootObservers = new WeakMap();
    this.upsellSelectionHandlers = new WeakMap();
    this.pendingShadowRootChecks = new WeakMap();
    this.pendingFormatFrames = new WeakMap();
    this.hairGummiesDefaultPlanSelected = false;
    this.hairGummiesSelectedMonth = null;
    this.gwpMonthlyPanelCollapsed = false;
    this.documentObserver = null;
  }

  init() {
    if (!document.body || this.documentObserver) {
      this.scan(document);
      return;
    }

    this.documentObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => this.scan(node));
        mutation.removedNodes.forEach((node) => this.cleanup(node));
      });
    });

    this.documentObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this.scan(document);
  }

  scan(scope) {
    this.collectElements(scope, "recharge-subscription-widget").forEach((widget) =>
      this.attachWidget(widget),
    );
  }

  cleanup(scope) {
    this.collectElements(scope, "recharge-subscription-widget").forEach((widget) =>
      this.detachWidget(widget),
    );
    this.collectElements(scope, "recharge-quantity-upsell").forEach((upsell) =>
      this.detachUpsell(upsell),
    );
  }

  collectElements(scope, selector) {
    if (!(scope instanceof Element) && scope !== document) return [];
    if (scope === document) return Array.from(document.querySelectorAll(selector));

    const elements = scope.matches(selector) ? [scope] : [];
    return elements.concat(Array.from(scope.querySelectorAll(selector)));
  }

  attachWidget(widget) {
    this.waitForShadowRoot(widget, (widgetRoot) => {
      if (!this.widgetRootObservers.has(widgetRoot)) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              this.collectElements(node, "recharge-quantity-upsell").forEach((upsell) =>
                this.attachUpsell(upsell),
              );
            });

            mutation.removedNodes.forEach((node) => {
              this.collectElements(node, "recharge-quantity-upsell").forEach((upsell) =>
                this.detachUpsell(upsell),
              );
            });
          });

          this.scheduleUpsellBadgeFormat(widgetRoot);
        });

        observer.observe(widgetRoot, {
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.widgetRootObservers.set(widgetRoot, observer);
      }

      this.collectElements(widgetRoot, "recharge-quantity-upsell").forEach((upsell) =>
        this.attachUpsell(upsell),
      );

      this.scheduleUpsellBadgeFormat(widgetRoot);
    });
  }

  detachWidget(widget) {
    this.cancelShadowRootCheck(widget);

    const widgetRoot = widget.shadowRoot;
    if (!widgetRoot) return;

    const observer = this.widgetRootObservers.get(widgetRoot);
    if (observer) {
      observer.disconnect();
      this.widgetRootObservers.delete(widgetRoot);
    }

    this.collectElements(widgetRoot, "recharge-quantity-upsell").forEach((upsell) =>
      this.detachUpsell(upsell),
    );
  }

  attachUpsell(upsell) {
    this.waitForShadowRoot(upsell, (upsellRoot) => {
      this.scheduleUpsellBadgeFormat(upsellRoot);

      if (this.upsellRootObservers.has(upsellRoot)) return;

      const observer = new MutationObserver(() => {
        this.scheduleUpsellBadgeFormat(upsellRoot);
      });

      observer.observe(upsellRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      this.upsellRootObservers.set(upsellRoot, observer);

      const selectionHandler = () => {
        this.scheduleUpsellBadgeFormat(upsellRoot);
      };
      upsellRoot.addEventListener("change", selectionHandler);
      upsellRoot.addEventListener("click", selectionHandler);
      this.upsellSelectionHandlers.set(upsellRoot, selectionHandler);
    });
  }

  detachUpsell(upsell) {
    this.cancelShadowRootCheck(upsell);

    const upsellRoot = upsell.shadowRoot;
    if (!upsellRoot) return;

    const frameId = this.pendingFormatFrames.get(upsellRoot);
    if (frameId !== undefined) {
      cancelAnimationFrame(frameId);
      this.pendingFormatFrames.delete(upsellRoot);
    }

    const observer = this.upsellRootObservers.get(upsellRoot);
    if (observer) {
      observer.disconnect();
      this.upsellRootObservers.delete(upsellRoot);
    }

    const selectionHandler = this.upsellSelectionHandlers.get(upsellRoot);
    if (selectionHandler) {
      upsellRoot.removeEventListener("change", selectionHandler);
      upsellRoot.removeEventListener("click", selectionHandler);
      this.upsellSelectionHandlers.delete(upsellRoot);
    }
  }

  scheduleUpsellBadgeFormat(upsellRoot) {
    if (this.pendingFormatFrames.has(upsellRoot)) return;

    const frameId = requestAnimationFrame(() => {
      this.pendingFormatFrames.delete(upsellRoot);
      this.selectHairGummiesDefaultPlan(upsellRoot);
      this.formatUpsellBadges(upsellRoot);
      if (window.themeSettings?.rechargePerBagPrice) {
        this.formatUpsellPricing(upsellRoot);
      }
      if (window.themeSettings?.rechargeSubscriptionOnly) {
        this.hideOnetimeOptions(upsellRoot);
      }
      this.formatHairGummiesSubscriptionBenefits(upsellRoot);
      this.syncHairGummiesMonthlyPanel(upsellRoot);
      this.syncHairGummiesMonthlyPopup(upsellRoot);
    });

    this.pendingFormatFrames.set(upsellRoot, frameId);
  }

  formatUpsellBadges(upsellRoot) {
    this.syncHairGummiesFreeBrushBadges(upsellRoot);

    upsellRoot
      .querySelectorAll(".rc-purchase-option__plan-discount-badge")
      .forEach((el) => {
        const currentText = el.textContent.trim();
        const match = currentText.match(/([\d.]+)%/);
        if (!match) return;

        const formattedText = `Save ${Math.round(parseFloat(match[1]))}%`;
        if (currentText === formattedText) return;

        el.textContent = formattedText;
      });
  }

  selectHairGummiesDefaultPlan(upsellRoot) {
    if (window.location.pathname !== "/products/hair-growth-gummies") return;
    if (this.hairGummiesDefaultPlanSelected) return;

    const threeMonthSellingPlanId = "4698964191";
    const threeMonthOption = this.findPurchaseOptions(upsellRoot).find((option) => {
      const input = option.querySelector("input[type='radio']");
      return (
        input?.value === threeMonthSellingPlanId ||
        input?.dataset.sellingPlanId === threeMonthSellingPlanId ||
        /3\s*[- ]?\s*month/i.test(this.findTitleText(option))
      );
    });
    const threeMonthInput = threeMonthOption?.querySelector("input[type='radio']");
    if (!threeMonthInput) return;

    // Apply the ticket's default only once. Later format passes must preserve
    // whichever plan the shopper selects.
    this.hairGummiesDefaultPlanSelected = true;
    if (!threeMonthInput.checked) threeMonthInput.click();
  }

  syncHairGummiesMonthlyPanel(upsellRoot) {
    const existingPanel = upsellRoot.querySelector("xt-gwp-monthly-upsell");
    if (
      window.location.pathname !== "/products/hair-growth-gummies" ||
      !window.themeSettings?.gwpOfferActive ||
      !window.XtresseGwpMonthly
    ) {
      existingPanel?.remove();
      return;
    }

    const options = this.findPurchaseOptions(upsellRoot)
      .filter((option) => !this.isOnetimeOption(option));
    const monthlyOption = options.find(
      (option) => this.getPurchaseOptionMonthCount(option) === 1,
    );
    const threeMonthOption = options.find(
      (option) => this.getPurchaseOptionMonthCount(option) === 3,
    );
    const monthlyInput = monthlyOption?.querySelector("input[type='radio']");
    const threeMonthInput = threeMonthOption?.querySelector("input[type='radio']");
    const selectedOption = this.findSelectedPurchaseOption(upsellRoot);
    const selectedMonth = selectedOption
      ? this.getPurchaseOptionMonthCount(selectedOption)
      : 0;

    if ([3, 6].includes(selectedMonth)) {
      this.gwpMonthlyPanelCollapsed = false;
    }

    if (
      !monthlyInput ||
      !threeMonthInput ||
      !selectedOption ||
      this.isOnetimeOption(selectedOption) ||
      selectedMonth !== 1 ||
      this.gwpMonthlyPanelCollapsed
    ) {
      existingPanel?.remove();
      return;
    }

    if (existingPanel) {
      if (monthlyOption.nextElementSibling !== existingPanel) {
        monthlyOption.after(existingPanel);
      }
      return;
    }

    const panel = document.createElement("xt-gwp-monthly-upsell");
    panel.addEventListener("gwp:switch-to-three-months", () => {
      const liveThreeMonthInput = this.findPurchaseOptions(upsellRoot)
        .filter((option) => !this.isOnetimeOption(option))
        .find((option) => this.getPurchaseOptionMonthCount(option) === 3)
        ?.querySelector("input[type='radio']");
      if (!liveThreeMonthInput) return;
      liveThreeMonthInput.focus();
      liveThreeMonthInput.click();
    });
    panel.addEventListener("gwp:keep-monthly", () => {
      const liveMonthlyInput = this.findPurchaseOptions(upsellRoot)
        .filter((option) => !this.isOnetimeOption(option))
        .find((option) => this.getPurchaseOptionMonthCount(option) === 1)
        ?.querySelector("input[type='radio']");
      liveMonthlyInput?.focus();
      this.gwpMonthlyPanelCollapsed = true;
      panel.remove();
    });
    monthlyOption.after(panel);
  }

  syncHairGummiesMonthlyPopup(upsellRoot) {
    if (window.location.pathname !== "/products/hair-growth-gummies") return;
    if (!window.themeSettings?.gwpOfferActive) return;

    const selectedOption = this.findSelectedPurchaseOption(upsellRoot);
    if (!selectedOption || this.isOnetimeOption(selectedOption)) return;

    const selectedMonth = this.getPurchaseOptionMonthCount(selectedOption);
    if (![1, 3, 6].includes(selectedMonth)) return;

    const previousMonth = this.hairGummiesSelectedMonth;
    this.hairGummiesSelectedMonth = selectedMonth;

    if (selectedMonth !== 1 || ![3, 6].includes(previousMonth)) return;
    window.XtresseGwpMonthly?.showPopup({
      storageKey: "gwp-monthly-popup-dismissed",
      trigger: selectedOption.querySelector("input[type='radio']"),
    });
  }

  syncHairGummiesFreeBrushBadges(upsellRoot) {
    if (window.location.pathname !== "/products/hair-growth-gummies") return;

    const gwpActive = Boolean(window.themeSettings?.gwpOfferActive);
    const options = this.findPurchaseOptions(upsellRoot);

    upsellRoot
      .querySelectorAll(
        ".rc-purchase-option__recommended-badge, .rc-purchase-option__best-value-badge",
      )
      .forEach((badge) => {
        if (
          badge.classList.contains("xt-plan-badge") ||
          badge.classList.contains("xt-free-brush-badge")
        ) {
          return;
        }
        badge.remove();
      });

    options.forEach((option) => {
      const monthCount = this.getPurchaseOptionMonthCount(option);
      const existing = Array.from(
        option.querySelectorAll(".xt-plan-badge, .xt-free-brush-badge"),
      );

      if (monthCount !== 3 && monthCount !== 6) {
        existing.forEach((badge) => badge.remove());
        return;
      }

      const label = gwpActive
        ? "free brush included"
        : monthCount === 3
          ? "Best Seller"
          : "Best Value";
      const badgeClass =
        "xt-plan-badge xt-free-brush-badge rc-purchase-option__recommended-badge";

      if (existing.length === 1) {
        if (existing[0].textContent !== label) existing[0].textContent = label;
        if (existing[0].className !== badgeClass) existing[0].className = badgeClass;
        return;
      }

      existing.forEach((badge) => badge.remove());

      const badge = document.createElement("span");
      badge.className = badgeClass;
      badge.textContent = label;
      option.prepend(badge);
    });
  }

  formatHairGummiesSubscriptionBenefits(upsellRoot) {
    if (window.location.pathname !== "/products/hair-growth-gummies") return;

    this.ensureWidgetStyles(upsellRoot);

    this.findPurchaseOptions(upsellRoot).forEach((option) => {
      if (this.isOnetimeOption(option)) return;

      const monthCount = this.getPurchaseOptionMonthCount(option);
      if (![1, 3, 6].includes(monthCount)) return;

      const gwpActive = Boolean(window.themeSettings?.gwpOfferActive);
      const showBrushBenefit = gwpActive && (monthCount === 3 || monthCount === 6);
      const deliveryText = monthCount === 1
        ? "Free Shipping, delivered monthly"
        : `Free Shipping, delivered every ${monthCount} months`;
      const signature = `${monthCount}:${gwpActive ? "gwp" : "nogwp"}`;
      let benefits = option.querySelector(".xt-subscription-benefits");

      if (!benefits || benefits.dataset.xtSignature !== signature) {
        benefits?.remove();
        benefits = document.createElement("ul");
        benefits.className = "xt-subscription-benefits";
        benefits.dataset.xtSignature = signature;

        const benefitItems = [];
        if (showBrushBenefit) {
          benefitItems.push({
            text: "Free Copper Paddle Brush included ($35 value)",
            emphasis: true,
          });
        }
        benefitItems.push(
          { text: deliveryText, emphasis: false },
          { text: "Skip, pause or cancel anytime", emphasis: false },
        );

        benefitItems.forEach(({ text, emphasis }) => {
          const benefit = document.createElement("li");
          benefit.className = emphasis
            ? "xt-subscription-benefit xt-subscription-benefit--emphasis"
            : "xt-subscription-benefit";
          benefit.textContent = text;
          benefits.appendChild(benefit);
        });

        const header = option.querySelector(".rc-quantity-upsell-option__header");
        if (!header) return;
        header.after(benefits);
      }

      const billed = option.querySelector(".xt-perbag-billed");
      const learnMore = option.querySelector("rc-learn-more");
      if (billed && learnMore && billed.nextElementSibling !== learnMore) {
        learnMore.before(billed);
      }
    });
  }

  hideRechargePauseCancelDuplicate(option) {
    option.querySelectorAll("rc-benefits").forEach((benefits) => {
      benefits.classList.remove("xt-recharge-hidden-benefits");

      const benefitsRoot = benefits.shadowRoot || benefits;
      const normalizeText = (text) =>
        String(text || "")
          .replace(/\s+/g, " ")
          .trim()
          .replace(/[.!]+$/, "")
          .toLowerCase();
      const isDuplicate = (element) =>
        /^pause or cancel any ?time$/.test(normalizeText(element.textContent));
      const candidates = Array.from(benefitsRoot.querySelectorAll("*"));
      const duplicate = candidates.find(
        (element) =>
          isDuplicate(element) &&
          !Array.from(element.children).some((child) => isDuplicate(child)),
      );
      if (!duplicate) return;

      let duplicateLine = duplicate;
      while (
        duplicateLine.parentElement &&
        duplicateLine.parentElement !== benefitsRoot &&
        isDuplicate(duplicateLine.parentElement)
      ) {
        duplicateLine = duplicateLine.parentElement;
      }

      duplicateLine.style.setProperty("display", "none", "important");
      duplicateLine.setAttribute("aria-hidden", "true");
    });
  }

  hideOnetimeOptions(upsellRoot) {
    const options = this.findPurchaseOptions(upsellRoot);
    if (options.length < 2) return;

    const onetimeOptions = options.filter((option) => this.isOnetimeOption(option));
    const subscriptionOptions = options.filter((option) => !this.isOnetimeOption(option));
    if (subscriptionOptions.length === 0) return;

    onetimeOptions.forEach((option) => {
      option.style.display = "none";
      option.setAttribute("aria-hidden", "true");
    });

    const anySelected = subscriptionOptions.some((option) => {
      const input = option.querySelector("input[type='radio']");
      return input && input.checked;
    });
    if (!anySelected) {
      const firstInput = subscriptionOptions[0].querySelector("input[type='radio']");
      if (firstInput) {
        firstInput.checked = true;
        firstInput.dispatchEvent(new Event("change", { bubbles: true }));
        firstInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
  }

  formatUpsellPricing(upsellRoot) {
    const options = this.findPurchaseOptions(upsellRoot);
    if (options.length < 2) return;

    const onetimeCents = this.findOnetimeCents(options);
    if (!onetimeCents) return;

    options.forEach((option) => {
      if (this.isOnetimeOption(option)) return;
      this.formatSubscriptionOption(option, onetimeCents);
    });
  }

  findPurchaseOptions(root) {
    let options = Array.from(
      root.querySelectorAll(".rc-purchase-option, .rc-quantity-upsell-option"),
    );
    if (options.length) return options;

    const seen = new Set();
    const candidates = [];
    const ancestorSelector =
      "[class*='purchase-option']:not([class*='__']), [class*='purchase_option']:not([class*='__']), [class*='--option']:not([class*='__']), [class*='__option']:not([class*='__option-'])";

    root
      .querySelectorAll(
        ".rc-purchase-option__plan-discount-badge, [class*='discount-badge'], [class*='__badge']",
      )
      .forEach((badge) => {
        let el = badge;
        for (let i = 0; i < 8 && el; i++) {
          el = el.parentElement;
          if (!el) break;
          if (el.matches && el.matches(ancestorSelector)) {
            if (!seen.has(el)) {
              seen.add(el);
              candidates.push(el);
            }
            break;
          }
        }
      });

    if (candidates.length) return candidates;

    return Array.from(root.querySelectorAll("[class*='purchase-option']")).filter(
      (el) => !el.className.match(/__(price|badge|description|label|plan-)/),
    );
  }

  findOnetimeCents(options) {
    for (const option of options) {
      if (!this.isOnetimeOption(option)) continue;
      const priceEl = this.findPriceEl(option);
      if (!priceEl) continue;
      const cents = parseMoneyCents(priceEl.textContent);
      if (cents > 0) return cents;
    }
    return 0;
  }

  isOnetimeOption(option) {
    const text = (option.textContent || "").toLowerCase();
    if (option.querySelector("[rc-onetime]")) return true;
    const input = option.querySelector("input[type='radio']");
    if (input && input.value === "") return true;
    if (text.includes("one-time") || text.includes("one time")) return true;
    return !option.querySelector(".rc-purchase-option__plan-discount-badge");
  }

  findPriceEl(option) {
    return (
      option.querySelector(".rc-purchase-option__price") ||
      option.querySelector("[class*='__price']:not([class*='compare']):not([class*='discount'])") ||
      Array.from(
        option.querySelectorAll(
          ".rc-quantity-upsell-option__header > div:last-child, .rc-quantity-upsell-option__header div",
        ),
      )
        .reverse()
        .find((el) => parseMoneyCents(el.textContent) > 0)
    );
  }

  findDescriptionEl(option) {
    return (
      option.querySelector(".rc-purchase-option__plan-description") ||
      option.querySelector(".rc-purchase-option__description") ||
      option.querySelector(".rc-quantity-upsell-option__content-container") ||
      option.querySelector("[class*='description']")
    );
  }

  findTitleText(option) {
    const titleEl =
      option.querySelector(".rc-quantity-upsell-option__title") ||
      option.querySelector(".rc-purchase-option__title") ||
      option.querySelector("[class*='__title']");
    return (titleEl || option).textContent || "";
  }

  getPurchaseOptionMonthCount(option) {
    const title = this.findTitleText(option);
    const match = title.match(/(\d+)\s*[- ]?\s*month/i);
    if (match) return Number.parseInt(match[1], 10);
    return /monthly/i.test(title) ? 1 : 0;
  }

  findSelectedPurchaseOption(root) {
    const options = this.findPurchaseOptions(root);
    const checkedOption = options.find((option) => {
      const input = option.querySelector("input[type='radio']");
      return input?.checked;
    });
    if (checkedOption) return checkedOption;
    return options.find((option) => option.hasAttribute("rc-selected"));
  }

  findDiscountPercent(option) {
    const badge = option.querySelector(".rc-purchase-option__plan-discount-badge");
    const match = badge?.textContent.match(/([\d.]+)%/);
    return match ? parseFloat(match[1]) : 0;
  }

  findItemCount(option, totalCents, onetimeCents) {
    const title = this.findTitleText(option);
    const titleMatch = title.match(/(\d+)\s*[- ]?\s*(month|bag|bottle|pack|supply)/i);
    if (titleMatch) return Math.max(1, parseInt(titleMatch[1], 10));
    if (/monthly|every\s+1\s+month/i.test(title)) return 1;

    const discountPercent = this.findDiscountPercent(option);
    if (discountPercent > 0 && discountPercent < 100) {
      const discountedBase = onetimeCents * (1 - discountPercent / 100);
      const count = Math.round(totalCents / discountedBase);
      if (count > 0) return count;
    }

    return Math.max(1, Math.round(totalCents / onetimeCents));
  }

  ensureWidgetStyles(root) {
    if (root.querySelector("style[data-xt-recharge-pricing]")) return;

    const style = document.createElement("style");
    style.dataset.xtRechargePricing = "true";
    style.textContent = `
      .xt-perbag-pricewrap {
        display: inline-flex;
        align-items: baseline;
        gap: 8px;
        white-space: nowrap;
      }

      .xt-perbag-strike {
        position: relative;
        font-size: 1em;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.5);
        text-decoration: none;
      }

      .xt-perbag-strike::after {
        content: "";
        position: absolute;
        left: -1px;
        right: -1px;
        top: 50%;
        height: 1.5px;
        background: rgba(0, 0, 0, 0.55);
        transform: translateY(-0.5px);
        pointer-events: none;
      }

      .xt-perbag-price {
        font: inherit;
        font-weight: inherit;
      }

      .xt-perbag-billed {
        margin-top: 16px;
        font-size: 0.875em;
        line-height: 1.4;
        color: rgba(0, 0, 0, 0.6);
        font-weight: 400;
      }

      .rc-quantity-upsell-option[rc-selected] .xt-perbag-billed {
        /* Offset Recharge's retained paragraph margin after its duplicate
           pause/cancel line is hidden, while preserving Learn More spacing. */
        margin-top: -1em;
      }

      .xt-perbag-billed strong {
        color: rgba(0, 0, 0, 0.85);
        font-weight: 600;
      }

      .xt-subscription-benefits {
        display: grid;
        gap: 4px;
        margin: 12px 0 0;
        padding: 0;
        list-style: none;
        font-size: 0.875em;
        line-height: 1.4;
        color: rgba(0, 0, 0, 0.75);
        font-weight: 400;
      }

      .xt-subscription-benefit {
        display: grid;
        grid-template-columns: 14px minmax(0, 1fr);
        gap: 6px;
        align-items: start;
      }

      .xt-subscription-benefit--emphasis {
        font-weight: 700;
        color: rgba(0, 0, 0, 0.9);
      }

      .xt-subscription-benefit::before {
        content: "\\2713";
        color: rgba(0, 0, 0, 0.9);
        font-weight: 700;
      }

      .rc-quantity-upsell-option[rc-not-selected] .xt-subscription-benefits {
        display: none;
      }
    `;
    root.appendChild(style);
  }

  formatSubscriptionOption(option, onetimeCents) {
    const root = option.getRootNode();
    if (root instanceof ShadowRoot) this.ensureWidgetStyles(root);

    // Recharge can replace this block after a plan selection. Reapply the
    // selective cleanup on every formatting pass while preserving its price
    // savings and supply/delivery lines from the approved subscription summary.
    this.hideRechargePauseCancelDuplicate(option);

    const priceEl = this.findPriceEl(option);
    if (!priceEl) return;

    const hasOurMarkup = !!priceEl.querySelector(".xt-perbag-price");
    const storedTotal = Number(priceEl.dataset.xtRcTotal || 0);
    const totalCents = hasOurMarkup && storedTotal
      ? storedTotal
      : parseMoneyCents(priceEl.textContent);
    if (!totalCents) return;

    const items = this.findItemCount(option, totalCents, onetimeCents);
    const perItemCents = Math.round(totalCents / items);
    const signature = `${totalCents}:${onetimeCents}:${items}`;

    if (hasOurMarkup && priceEl.dataset.xtSignature === signature) {
      this.syncBilledDescription(option, totalCents, items);
      return;
    }

    const perItemText = formatMoneyShort(perItemCents);
    const onetimeText = formatMoneyShort(onetimeCents);
    const showStrike = onetimeCents > perItemCents;

    priceEl.innerHTML = showStrike
      ? `<span class="xt-perbag-pricewrap"><span class="xt-perbag-strike">${onetimeText}</span><span class="xt-perbag-price">${perItemText}</span></span>`
      : `<span class="xt-perbag-price">${perItemText}</span>`;
    priceEl.dataset.xtRcTotal = String(totalCents);
    priceEl.dataset.xtSignature = signature;
    priceEl.removeAttribute("aria-hidden");
    priceEl.style.removeProperty("display");

    this.syncBilledDescription(option, totalCents, items);
  }

  syncBilledDescription(option, totalCents, items) {
    option.querySelectorAll(".xt-perbag-billed").forEach((n) => n.remove());
    if (items <= 1) return;

    const descEl = this.findDescriptionEl(option);
    if (!descEl) return;

    const billed = document.createElement("div");
    billed.className = "xt-perbag-billed";
    billed.innerHTML = `Billed <strong>${formatMoneyShort(totalCents)}</strong> every ${items} months.`;
    descEl.appendChild(billed);
  }

  waitForShadowRoot(element, onReady) {
    if (element.shadowRoot) {
      onReady(element.shadowRoot);
      return;
    }

    if (this.pendingShadowRootChecks.has(element)) return;

    let attempts = 0;
    const maxAttempts = 120;

    const check = () => {
      if (!element.isConnected) {
        this.pendingShadowRootChecks.delete(element);
        return;
      }

      if (element.shadowRoot) {
        this.pendingShadowRootChecks.delete(element);
        onReady(element.shadowRoot);
        return;
      }

      if (attempts >= maxAttempts) {
        this.pendingShadowRootChecks.delete(element);
        return;
      }

      attempts += 1;
      const frameId = requestAnimationFrame(check);
      this.pendingShadowRootChecks.set(element, frameId);
    };

    const frameId = requestAnimationFrame(check);
    this.pendingShadowRootChecks.set(element, frameId);
  }

  cancelShadowRootCheck(element) {
    const frameId = this.pendingShadowRootChecks.get(element);
    if (frameId === undefined) return;

    cancelAnimationFrame(frameId);
    this.pendingShadowRootChecks.delete(element);
  }
}

function parseMoneyCents(text) {
  if (!text) return 0;
  const cleaned = String(text).replace(/[^\d.,-]/g, "");
  if (!cleaned) return 0;
  const lastDot = cleaned.lastIndexOf(".");
  const lastComma = cleaned.lastIndexOf(",");
  const sepPos = Math.max(lastDot, lastComma);
  if (sepPos === -1) {
    const n = parseInt(cleaned, 10);
    return Number.isFinite(n) ? n * 100 : 0;
  }
  const afterSep = cleaned.length - sepPos - 1;
  if (afterSep >= 1 && afterSep <= 2) {
    const whole = parseInt(cleaned.slice(0, sepPos).replace(/[.,]/g, ""), 10) || 0;
    const frac = parseInt(cleaned.slice(sepPos + 1).padEnd(2, "0").slice(0, 2), 10) || 0;
    return whole * 100 + frac;
  }
  const n = parseInt(cleaned.replace(/[.,]/g, ""), 10);
  return Number.isFinite(n) ? n : 0;
}

function formatMoneyShort(cents) {
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  return "$" + (cents / 100).toFixed(2);
}

const rechargeDiscountBadgeFormatter = new RechargeDiscountBadgeFormatter();

document.addEventListener("click", (event) => {
  const link = event.target.closest("[data-onetime-add]");
  if (!link) return;
  event.preventDefault();

  const productForm = link.closest("[data-buy-buttons-container], section, body")
    ?.querySelector("product-form");
  const form = productForm?.querySelector("form");
  if (!form) return;

  const variantId = link.dataset.variantId
    || form.querySelector("[name='id']")?.value;
  if (!variantId) return;

  const idInput = form.querySelector("[name='id']");
  const previousId = idInput?.value;
  if (idInput) idInput.value = variantId;

  const sellingPlanInputs = form.querySelectorAll("[name='selling_plan']");
  const sellingPlanValues = [];
  sellingPlanInputs.forEach((input) => {
    sellingPlanValues.push(input.value);
    input.value = "";
  });

  const restore = () => {
    if (idInput && previousId !== undefined) idInput.value = previousId;
    sellingPlanInputs.forEach((input, i) => {
      input.value = sellingPlanValues[i];
    });
  };

  form.requestSubmit
    ? form.requestSubmit()
    : form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));

  setTimeout(restore, 0);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Custom video controls
document.addEventListener('DOMContentLoaded', () => {
  rechargeDiscountBadgeFormatter.init();
  markComplianceDisclaimers();

  const BUTTON_SELECTOR = '.wt-hero-video__sound-toggle';
  const BUTTON_TOGGLE_CLASS = 'wt-hero-video__sound-toggle--unmuted';

  document.querySelectorAll(BUTTON_SELECTOR).forEach(button => {
    button.addEventListener('click', () => {
      const parent = button.parentElement;
      if (!parent) return;

      let video = null;

      video = Array.from(parent.children).find(
          el => el.tagName === 'VIDEO'
      );

      if (!video) {
        const heroVideoContainer = Array.from(parent.children).find(
            el => el.classList && el.classList.contains('hero--video-background')
        );

        if (heroVideoContainer) {
          video = heroVideoContainer.querySelector('video');
        }
      }

      if(!video){
          const grandparent = parent.closest('video-controls');
          console.log(grandparent);
          video = Array.from(grandparent.children).find(
            el => el.tagName === 'VIDEO'
        );
      }

      if (!video) return;

      video.muted = !video.muted;
      button.classList.toggle(BUTTON_TOGGLE_CLASS, !video.muted);
    });
  });
});

document.addEventListener("shopify:section:load", (event) => {
  markComplianceDisclaimers(event.target);
});

document.addEventListener("quickview:loaded", (event) => {
  rechargeDiscountBadgeFormatter.scan(event.detail?.container || document);
});
